import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }) => ({
  // The optional-cover copy with its on/off switch to the right.
  toggleRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16
  },
  // One field per row; SInput (newDesign) brings its own bottom spacing.
  fieldsColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  templatesRow: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap'
  },
  templateThumb: {
    width: 96,
    height: 128,
    borderRadius: 8,
    border: '2px solid #C5CDD5',
    background: '#fff',
    cursor: 'pointer',
    overflow: 'hidden'
  },
  templateThumbSelected: {
    borderColor: palette.primary.main
  },
  // No cover can be picked while a detail is invalid or one is generating.
  templateThumbDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed'
  },
  emptyTemplates: {
    width: '100%',
    padding: '24px 0',
    borderRadius: 8,
    border: '1px dashed #C5CDD5',
    textAlign: 'center'
  }
}));
